import {IAnyObject} from "../../common/SimpleInterface";

export default class UserProfile
{
    userID:number = 0;
    email:string = "";
    firstName:string = "";
    lastName:string = "";
    apiUser:IAnyObject | null = null;

    getName(): string
    {
        const space = this.firstName && this.lastName ? " " : "";
        return this.firstName + space + this.lastName;
    }
}